import { render, staticRenderFns } from "./ConfusionMatrixPage.vue?vue&type=template&id=011c8f0c&scoped=true"
import script from "./ConfusionMatrixPage.vue?vue&type=script&lang=js"
export * from "./ConfusionMatrixPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c8f0c",
  null
  
)

export default component.exports